import { createFileRoute } from '@tanstack/react-router';

import { HStack } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

import MainCard from './-components/MainCard';

export const Route = createFileRoute(
  '/_staff/time-and-attendance/_layout/attendance-links/$placeId/',
)({
  component: AttendanceLinkForPlacePage,
});

function AttendanceLinkForPlacePage() {
  const { placeId } = Route.useParams();
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.timeAndAttendance.attendanceLinks',
  });

  useDocumentTitle(t('pageTitle'));

  return (
    <div className="p-6">
      <HStack className="items-start gap-8">
        <div className="flex-2 max-w-[1200px]">
          <MainCard placeId={placeId} />
        </div>
        {/* 営業用デザインがあるのみで、実際の機能はないため */}
        {/* <VStack className="flex-1 gap-8 min-w-0">
          <div className="w-full">
            <ProgressCard />
          </div>
          <div className="w-full">
            <ReferencesCard />
          </div>
        </VStack> */}
      </HStack>
    </div>
  );
}
